import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { readFile } from '../../../helpers/cropImageHelper';

export const useImageUpload = (setImage, setFileName, isImageChanged) => {
  const formContext = useFormContext();
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);

  const handleImageChange = async (event) => {
    const newFiles = event?.target?.files || event?.dataTransfer?.files;
    if (newFiles.length > 0 && newFiles[0].type.startsWith('image/')) {
      setFileName(newFiles[0]?.name || 'petProfileImage.jpg');
      const imageDataUrl = await readFile(newFiles[0]);
      setImage(imageDataUrl);
      isImageChanged(true);
    }
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files[0];
      if (file.type.startsWith('image/')) {
        setFileName(file[0]?.name || 'petProfileImage.jpg');
        const imageDataUrl = await readFile(file);
        setImage(imageDataUrl);
      }
    }
  };

  const imageFileTypes = [
    'image/apng',
    'image/gif',
    'image/jpeg',
    'image/pjpeg',
    'image/png',
    'image/tiff',
    'image/webp'
  ];

  const validImageFiles = {
    extensions: imageFileTypes,
    fileTypes: 'images',
    supportsLabel: 'png, apng, jpeg, pjpeg, png, tiff, webp'
  };

  return {
    formContext,
    handleImageChange,
    handleDrop,
    crop,
    setCrop,
    zoom,
    setZoom,
    validImageFiles
  };
};
